var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user page normal-page"},[_c('div',{staticClass:"web-content"},[_c('div',{staticClass:"page-structure"},[_c('PageMenu',{attrs:{"menu-data":_vm.pageMenu}}),_c('div',{staticClass:"page-content"},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }